const ShiftLogPriority = ["High", "Low"] as const;
type ShiftLogPriority = typeof ShiftLogPriority[number]

export default ShiftLogPriority;
